import React from 'react';

import {getClasses} from '../../utils/helpers';

export default function Loader({isButton}) {
  const loaderClasses = getClasses({
    'auth-modal__loader': true,
    'auth-modal__loader--in-button': isButton
  });

  return (
    <div className={loaderClasses}>
      <div className='auth-modal__loader-spin' />
    </div>
  );
}
